import {
  UPDATE_REFERENCES,
  POST_PROJECT,
  UPDATE_PROJECT,
  UPDATE_PROJECT_SUCCESS,
  GET_PROJECT_LIST,
  GET_PROJECT_DETAILS,
  GET_WORKFLOW_DETAILS,
  POST_UPDATE_PROJECT,
  POST_UPDATE_PROJECT_START,
  POST_UPDATE_PROJECT_SUCCESS,
  POST_UPDATE_PROJECT_ERROR,
  SET_ISLOADED,
  RESET_ISLOADED,
  LOAD_PROJECT_FORM,
  SET_FORM_STATUS,
  POST_WORKFLOW_SUBMIT,
  POST_WORKFLOW_SUBMIT_START,
  POST_WORKFLOW_SUBMIT_SUCCESS,
  POST_WORKFLOW_SUBMIT_ERROR,
  POST_WORKFLOW_RESTART,
  POST_WORKFLOW_RESTART_START,
  POST_WORKFLOW_RESTART_SUCCESS,
  POST_WORKFLOW_RESTART_ERROR,
  FETCH_FORM_ELEMENTS,
  FETCH_FORM_ELEMENTS_START,
  FETCH_FORM_ELEMENTS_SUCCESS,
  FETCH_FORM_ELEMENTS_ERROR,
  FETCH_ELEMENT_REFERENCES,
  FETCH_ELEMENT_REFERENCES_START,
  FETCH_ELEMENT_REFERENCES_SUCCESS,
  FETCH_ELEMENT_REFERENCES_ERROR,
  LOAD_PROJECT_FORM_DATA,
  LOAD_PROJECT_FORM_DATA_START,
  LOAD_PROJECT_FORM_DATA_SUCCESS,
} from './constants'
import {
  FETCH_PROJECT_REVISIONS_ERROR,
  FETCH_REVISION_DATA_ERROR
} from 'containers/Project/Revision/constants'
import {
  clearTables,
} from 'containers/Entity/actions'
import {
  clearFormElements,
} from 'containers/Form/actions'
import {
  getRequest,
  postRequest,
} from 'helpers/RequestUtil'
import {
  asyncReduxFilter
} from 'containers/Async/actions'
import {
  asyncReduxPromiseFilter,
} from 'containers/Async/actions'
import {
  clearUiFormElements,
} from 'containers/UiState/actions'
import {
  resetUiRestricted,
} from 'containers/Form/Restricted/actions'
import {
  getProjectInfoAction,
  updateProjectInfoId,
  updateProjectInfoWorkflowId,
} from './Overview/actions'
import {
  loadDefaultFormData,
} from 'containers/Form/actions'
import {
  clearProjectInfo,
  getProjectDetails as getUpdateProjectDetails,
} from './View/actions'
import {
  isLoadedSelector
} from './selectors'
import {
  buildAsyncAction
} from 'containers/Async/actions'

const loadProjectForm = (projectId, isUpdatePage = false) => {
  return (dispatch, getState) => {
    let promise = Promise.resolve(null)
    const isLoaded = isLoadedSelector(getState())

    if (!isLoaded) {
      promise = dispatch(loadProjectAsync(projectId, isUpdatePage))
    }
    return promise
  }
}

const loadProject = (projectId, isUpdatePage) => {
  return dispatch => {
    return dispatch(getProjectInfoAction(projectId))
      .then(projectId => {
        let promise = Promise.resolve(null)

        if (isUpdatePage) {
          promise = dispatch(getUpdateProjectDetails(projectId))
          dispatch(loadProjectFormData(projectId))
        } else {
          dispatch(loadProjectFormData(projectId))
        }

        return promise
      })
      .then(() => dispatch(setIsLoaded()))
  }
}

const loadProjectAsync = asyncReduxFilter(LOAD_PROJECT_FORM, loadProject)

// For triggering Specifications selector
const setFormStatus = (status) => {
  return {
    type: SET_FORM_STATUS,
    status,
  }
}

const postProject = (params) => (
  asyncReduxPromiseFilter(
    POST_PROJECT,
    postRequest,
  )('creates', params, '/api/fulcrum/project/creates')
)

const getProjectDetails = projectId => (
  asyncReduxPromiseFilter(
    GET_PROJECT_DETAILS,
    getRequest
  )(`/api/fulcrum/project/details/${projectId}`)
)

const updateProject = (params) => (
  asyncReduxPromiseFilter(
    UPDATE_PROJECT,
    postRequest
  )('updates', params, '/api/fulcrum/project/updates')
)

const getWorkflowDetails = workflowId => (
  asyncReduxPromiseFilter(
    GET_WORKFLOW_DETAILS,
    getRequest
  )(`/api/fulcrum/workflows/${workflowId}/detail`)
)

const createProject = (productHierarchyId, partnerSiteId, productClassTypeId) => {
  return dispatch => {
    const params = {
      partnerSiteId,
      productHierarchyId,
      productClassTypeId,
      formData: {}
    }

    return dispatch(postProject(params))
  }
}

const getProjectList = (query) => {
  const projectListUrl = '/api/fulcrum/project/lists'
  let url = query ? `${projectListUrl}?filter[search]=${query}` : projectListUrl

  return asyncReduxPromiseFilter(
    GET_PROJECT_LIST,
    getRequest
  )(url)
}

const getProjectFormUrl = projectId => `/api/fulcrum/project/forms/${projectId}/elements`

// New for sagas
/////////////////////////////////////////////////////////////////////////////////

// Form Start

const fetchFormElements = (projectId) => ({ type: FETCH_FORM_ELEMENTS, projectId })
const fetchFormElementsStart = () => ({ type: FETCH_FORM_ELEMENTS_START })
const fetchFormElementsSuccess = () => ({ type: FETCH_FORM_ELEMENTS_SUCCESS })
const fetchFormElementsError = (error) => ({ type: FETCH_FORM_ELEMENTS_ERROR, error })
const startFetchFormElements = buildAsyncAction(
  FETCH_FORM_ELEMENTS,
  FETCH_FORM_ELEMENTS_START,
  [FETCH_FORM_ELEMENTS_SUCCESS, FETCH_FORM_ELEMENTS_ERROR]
)

const fetchElementReferences = (projectId, params) => ({ type: FETCH_ELEMENT_REFERENCES, projectId, params })
const fetchElementReferencesStart = () => ({ type: FETCH_ELEMENT_REFERENCES_START })
const fetchElementReferencesSuccess = () => ({ type: FETCH_ELEMENT_REFERENCES_SUCCESS })
const fetchElementReferencesError = (error) => ({ type: FETCH_ELEMENT_REFERENCES_ERROR, error })
const startFetchElementReferences = buildAsyncAction(
  FETCH_ELEMENT_REFERENCES,
  FETCH_ELEMENT_REFERENCES_START,
  [FETCH_ELEMENT_REFERENCES_SUCCESS, FETCH_ELEMENT_REFERENCES_ERROR]
)

const loadProjectFormData = (projectId) => ({ type: LOAD_PROJECT_FORM_DATA, projectId })
const loadProjectFormDataSuccess = () => ({ type: LOAD_PROJECT_FORM_DATA_SUCCESS })
const loadProjectFormDataStart = () => ({ type: LOAD_PROJECT_FORM_DATA_START })
const startLoadProjectFormData = buildAsyncAction(
  LOAD_PROJECT_FORM_DATA,
  LOAD_PROJECT_FORM_DATA_START,
  [
    LOAD_PROJECT_FORM_DATA_SUCCESS,
    FETCH_FORM_ELEMENTS_ERROR,
    FETCH_PROJECT_REVISIONS_ERROR,
    FETCH_ELEMENT_REFERENCES_ERROR,
    FETCH_REVISION_DATA_ERROR
  ]
)
const updateProjectSuccess = () => ({ type: UPDATE_PROJECT_SUCCESS })

// Form End

const updateReferences = (refs) => ({ type: UPDATE_REFERENCES, refs })

const startPostUpdateProject = buildAsyncAction(
  POST_UPDATE_PROJECT,
  POST_UPDATE_PROJECT_START,
  [POST_UPDATE_PROJECT_SUCCESS, POST_UPDATE_PROJECT_ERROR]
)
const postUpdateProject = (projectId, workflowId, isNewProject = false) => {
  return ({ type: POST_UPDATE_PROJECT, projectId, workflowId, isNewProject })
}
const postUpdateProjectStart = () => ({ type: POST_UPDATE_PROJECT_START })
const postUpdateProjectSuccess = () => ({ type: POST_UPDATE_PROJECT_SUCCESS })
const postUpdateProjectError = (error) => ({ type: POST_UPDATE_PROJECT_ERROR, error })
const clearUiState = () => {
  return dispatch => {
    dispatch(clearUiFormElements())
    dispatch(resetUiRestricted())
  }
}

const clearData = () => {
  return dispatch => {
    dispatch(clearTables())
    dispatch(clearFormElements())
    dispatch(clearProjectInfo())
    dispatch(clearUiState())
    dispatch(resetIsLoaded())
  }
}


export const setIsLoaded = () => {
  return {
    type: SET_ISLOADED,
  }
}

export const resetIsLoaded = () => {
  return {
    type: RESET_ISLOADED,
  }
}

const startPostWorkflowSubmit = buildAsyncAction(
  POST_WORKFLOW_SUBMIT,
  POST_WORKFLOW_SUBMIT_START,
  [POST_WORKFLOW_SUBMIT_SUCCESS, POST_WORKFLOW_SUBMIT_ERROR]
)
const postWorkflowSubmit = (projectId, workflowId) => ({ type: POST_WORKFLOW_SUBMIT, projectId, workflowId })
const postWorkflowSubmitStart = () => ({ type: POST_WORKFLOW_SUBMIT_START })
const postWorkflowSubmitSuccess = () => ({ type: POST_WORKFLOW_SUBMIT_SUCCESS })
const postWorkflowSubmitError = (error) => ({ type: POST_WORKFLOW_SUBMIT_ERROR, error })

const startPostWorkflowRestart = buildAsyncAction(
  POST_WORKFLOW_RESTART,
  POST_WORKFLOW_RESTART_START,
  [POST_WORKFLOW_RESTART_SUCCESS, POST_WORKFLOW_RESTART_ERROR]
)
const postWorkflowRestart = (projectId, workflowId) => ({ type: POST_WORKFLOW_RESTART, projectId, workflowId })
const postWorkflowRestartStart = () => ({ type: POST_WORKFLOW_RESTART_START })
const postWorkflowRestartSuccess = () => ({ type: POST_WORKFLOW_RESTART_SUCCESS })
const postWorkflowRestartError = (error) => ({ type: POST_WORKFLOW_RESTART_ERROR, error })

export {
  getProjectList,
  getProjectDetails,
  createProject,
  updateProject,
  getProjectFormUrl,
  getWorkflowDetails,
  startPostUpdateProject,
  postUpdateProject,
  postUpdateProjectStart,
  postUpdateProjectSuccess,
  postUpdateProjectError,
  clearUiState,
  clearData,
  loadProjectForm,
  setFormStatus,
  startPostWorkflowSubmit,
  postWorkflowSubmit,
  postWorkflowSubmitStart,
  postWorkflowSubmitSuccess,
  postWorkflowSubmitError,
  startPostWorkflowRestart,
  postWorkflowRestart,
  postWorkflowRestartStart,
  postWorkflowRestartSuccess,
  postWorkflowRestartError,
  /* Forms */
  fetchFormElements,
  fetchFormElementsStart,
  fetchFormElementsSuccess,
  fetchFormElementsError,
  startFetchFormElements,
  fetchElementReferences,
  fetchElementReferencesStart,
  fetchElementReferencesSuccess,
  fetchElementReferencesError,
  startFetchElementReferences,
  loadProjectFormData,
  loadProjectFormDataSuccess,
  loadProjectFormDataStart,
  updateReferences,
  updateProjectSuccess,
  startLoadProjectFormData,
}
